// Placeholder data configuration for Home page sections
export const homeData = {
  trendingPieces: [
    {
      id: 1,
      title: "Neon Dreams Jacket",
      name: "Neon Dreams Jacket",
      creator: "@digitalartist",
      creatorVerified: true,
      image: "/images/piece-placeholder.png",
      link: "/trending",
      price: "2.5",
      category: "tops",
      color: "neon green",
      description: "A futuristic jacket with glowing neon accents and cyberpunk styling.",
      createdAt: "2024-09-09T10:30:00Z",
      brand: "CyberNova",
      rarity: "Rare",
      quantity: 1,
      totalMade: 25,
      thumbnail: { dataUrl: "/images/piece-placeholder.png" },
      views: 1250,
      likes: 89,
      downloads: 12,
      sold: 18
    },
    {
      id: 2,
      title: "Cyberpunk Helmet",
      name: "Cyberpunk Helmet",
      creator: "@techwear",
      creatorVerified: false,
      image: "/images/piece-placeholder.png",
      link: "/trending",
      price: "1.8",
      category: "accessories",
      color: "metallic silver",
      description: "High-tech helmet with integrated HUD display and sleek design.",
      createdAt: "2024-09-08T14:20:00Z",
      brand: "TechWear",
      rarity: "Uncommon",
      quantity: 1,
      totalMade: 50,
      thumbnail: { dataUrl: "/images/piece-placeholder.png" },
      views: 980,
      likes: 67,
      downloads: 8,
      sold: 12
    },
    {
      id: 3,
      title: "Holographic Shoes",
      name: "Holographic Shoes",
      creator: "@futurefashion",
      creatorVerified: true,
      image: "/images/piece-placeholder.png",
      link: "/trending",
      price: "3.2",
      category: "shoes",
      color: "holographic",
      description: "Sneakers with holographic material that shifts colors in the light.",
      createdAt: "2024-09-07T09:15:00Z",
      brand: "FutureFashion",
      rarity: "Rare",
      quantity: 1,
      totalMade: 30,
      thumbnail: { dataUrl: "/images/piece-placeholder.png" },
      views: 2100,
      likes: 156,
      downloads: 23,
      sold: 22
    },
    {
      id: 4,
      title: "Quantum Glasses",
      name: "Quantum Glasses",
      creator: "@visionary",
      creatorVerified: true,
      image: "/images/piece-placeholder4.png",
      link: "/trending",
      price: "1.5",
      category: "accessories",
      color: "crystal clear",
      description: "Smart glasses with quantum display technology and AR capabilities.",
      createdAt: "2024-09-06T16:45:00Z"
    },
    {
      id: 5,
      title: "Neural Interface",
      name: "Neural Interface",
      creator: "@cybernetics",
      creatorVerified: false,
      image: "/images/piece-placeholder5.png",
      link: "/trending",
      price: "4.9",
      category: "accessories",
      color: "neural blue",
      description: "Advanced neural interface device for direct brain-computer interaction.",
      createdAt: "2024-09-05T11:30:00Z"
    },
    {
      id: 6,
      title: "Plasma Watch",
      name: "Plasma Watch",
      creator: "@luxurytech",
      creatorVerified: true,
      image: "/images/piece-placeholder6.png",
      link: "/trending",
      price: "2.7",
      category: "accessories",
      color: "plasma orange",
      description: "Luxury timepiece with plasma display and premium materials.",
      createdAt: "2024-09-04T13:20:00Z"
    },
    {
      id: 7,
      title: "Crystal Ring",
      name: "Crystal Ring",
      creator: "@jewelry3d",
      image: "/images/piece-placeholder7.png",
      link: "/trending",
      price: "0.8",
      category: "accessories",
      color: "crystal clear",
      description: "Elegant ring with embedded crystal that glows softly.",
      createdAt: "2024-09-03T08:10:00Z"
    },
    {
      id: 8,
      title: "Aether Mask",
      name: "Aether Mask",
      creator: "@mysticdesign",
      image: "/images/piece-placeholder8.png",
      link: "/trending",
      price: "3.4",
      category: "accessories",
      color: "ethereal white",
      description: "Mystical mask with flowing aether effects and ancient design.",
      createdAt: "2024-09-02T15:35:00Z"
    },
    {
      id: 9,
      title: "Neon Pants",
      name: "Neon Pants",
      creator: "@streetwear3d",
      image: "/images/piece-placeholder9.png",
      link: "/trending",
      price: "1.9",
      category: "bottoms",
      color: "neon pink",
      description: "Streetwear pants with neon piping and futuristic street style.",
      createdAt: "2024-09-01T12:00:00Z"
    },
    {
      id: 10,
      title: "Holographic Hoodie",
      name: "Holographic Hoodie",
      creator: "@futurewear",
      image: "/images/piece-placeholder10.png",
      link: "/trending",
      price: "4.1",
      category: "tops",
      color: "holographic",
      description: "Comfortable hoodie with holographic fabric that changes patterns.",
      createdAt: "2024-08-31T17:25:00Z"
    },
    {
      id: 11,
      title: "Cyber Gloves",
      name: "Cyber Gloves",
      creator: "@techaccessories",
      image: "/images/piece-placeholder11.png",
      link: "/trending",
      price: "1.3",
      category: "accessories",
      color: "cyber black",
      description: "Tactical gloves with integrated tech features and sleek design.",
      createdAt: "2024-08-30T10:40:00Z"
    },
    {
      id: 12,
      title: "Quantum Belt",
      name: "Quantum Belt",
      creator: "@luxurygear",
      image: "/images/piece-placeholder12.png",
      link: "/trending",
      price: "2.2",
      category: "accessories",
      color: "quantum purple",
      description: "Luxury belt with quantum field effects and premium materials.",
      createdAt: "2024-08-29T14:15:00Z"
    },
    {
      id: 13,
      title: "Neural Headset",
      name: "Neural Headset",
      creator: "@cybertech",
      image: "/images/piece-placeholder13.png",
      link: "/trending",
      price: "5.3",
      category: "accessories",
      color: "neural green",
      description: "Advanced headset for neural interface and immersive experiences.",
      createdAt: "2024-08-28T09:50:00Z"
    },
    {
      id: 14,
      title: "Plasma Boots",
      name: "Plasma Boots",
      creator: "@futureshoes",
      image: "/images/piece-placeholder14.png",
      link: "/trending",
      price: "3.7",
      category: "shoes",
      color: "plasma red",
      description: "High-tech boots with plasma energy effects and futuristic design.",
      createdAt: "2024-08-27T16:30:00Z"
    },
    {
      id: 15,
      title: "Crystal Necklace",
      name: "Crystal Necklace",
      creator: "@jewelry3d",
      image: "/images/piece-placeholder15.png",
      link: "/trending",
      price: "1.6",
      category: "accessories",
      color: "crystal blue",
      description: "Elegant necklace with floating crystal pendant and mystical aura.",
      createdAt: "2024-08-26T11:45:00Z"
    }
  ],

  featuredCapsules: [
    {
      id: 1,
      title: "Digital Fashion Week",
      description: "Exclusive collection from top 3D designers showcasing the future of fashion.",
      banner: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=300&fit=crop",
      image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=300&fit=crop",
      link: "/capsules/1",
      featured: true,
      pieceCount: 8,
      avgPrice: 2.8,
      dropDate: "2024-01-15",
      creator: {
        name: "CyberVogue",
        verified: true
      }
    },
    {
      id: 2,
      title: "Cyberpunk Essentials",
      description: "Essential pieces for the modern cyberpunk aesthetic.",
      banner: "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=400&h=300&fit=crop",
      image: "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=400&h=300&fit=crop",
      link: "/capsules/2",
      featured: false,
      pieceCount: 5,
      avgPrice: 1.9,
      dropDate: "2024-01-10",
      creator: {
        name: "NeonDreamer",
        verified: false
      }
    },
    {
      id: 3,
      title: "Luxury Tech Collection",
      description: "High-end accessories for the tech-savvy elite.",
      banner: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop",
      link: "/capsules/3",
      featured: false,
      pieceCount: 6,
      avgPrice: 4.2,
      dropDate: "2024-01-08",
      creator: {
        name: "QuantumFashion",
        verified: true
      }
    },
    {
      id: 4,
      title: "Neon Dreams Collection",
      description: "Vibrant digital fashion pieces with futuristic neon aesthetics.",
      banner: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
      image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
      link: "/capsules/4",
      featured: true,
      pieceCount: 7,
      avgPrice: 2.5,
      dropDate: "2024-01-05",
      creator: {
        name: "HoloDesigner",
        verified: true
      }
    },
    {
      id: 5,
      title: "Quantum Wearables",
      description: "Advanced tech-integrated fashion for the modern digital lifestyle.",
      banner: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop",
      image: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop",
      link: "/capsules/5",
      featured: false,
      pieceCount: 4,
      avgPrice: 3.1,
      dropDate: "2024-01-03",
      creator: {
        name: "TechWearX",
        verified: false
      }
    },
    {
      id: 6,
      title: "Holographic Styles",
      description: "Cutting-edge holographic fashion pieces that redefine digital aesthetics.",
      banner: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=300&fit=crop",
      image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=300&fit=crop",
      link: "/capsules/6",
      featured: false,
      pieceCount: 9,
      avgPrice: 2.1,
      dropDate: "2024-01-01",
      creator: {
        name: "LuxuryCrypto",
        verified: true
      }
    }
  ],

  topCreators: [
    {
      id: 1,
      name: "CyberVogue",
      handle: "@cybervogue",
      avatar: "/images/placeholder-avatar-1.png",
      pieces: "47 pieces",
      volume: "124.5 SOL",
      verified: true,
      link: "/creators"
    },
    {
      id: 2,
      name: "NeonDreamer",
      handle: "@neondreamer",
      avatar: null,
      pieces: "32 pieces",
      volume: "89.2 SOL",
      verified: false,
      link: "/creators"
    },
    {
      id: 3,
      name: "QuantumFashion",
      handle: "@quantumfashion",
      avatar: "/images/placeholder-avatar-3.png",
      pieces: "58 pieces",
      volume: "156.7 SOL",
      verified: true,
      link: "/creators"
    },
    {
      id: 4,
      name: "HoloDesigner",
      handle: "@holodesigner",
      avatar: "/images/placeholder-avatar-4.png",
      pieces: "28 pieces",
      volume: "67.3 SOL",
      verified: true,
      link: "/creators"
    },
    {
      id: 5,
      name: "TechWearX",
      handle: "@techwearx",
      avatar: null,
      pieces: "41 pieces",
      volume: "98.6 SOL",
      verified: false,
      link: "/creators"
    },
    {
      id: 6,
      name: "LuxuryCrypto",
      handle: "@luxurycrypto",
      avatar: "/images/placeholder-avatar-6.png",
      pieces: "35 pieces",
      volume: "112.4 SOL",
      verified: true,
      link: "/creators"
    },
    {
      id: 7,
      name: "CyberPunk3D",
      handle: "@cyberpunk3d",
      avatar: null,
      pieces: "42 pieces",
      volume: "98.7 SOL",
      link: "/creators"
    },
    {
      id: 8,
      name: "NeonVibes",
      handle: "@neonvibes",
      avatar: "/images/placeholder-avatar-8.png",
      pieces: "29 pieces",
      volume: "76.3 SOL",
      link: "/creators"
    },
    {
      id: 9,
      name: "DigitalArtX",
      handle: "@digitalartx",
      avatar: null,
      pieces: "51 pieces",
      volume: "134.2 SOL",
      link: "/creators"
    },
    {
      id: 10,
      name: "FuturisticFashion",
      handle: "@futuristicfashion",
      avatar: "/images/placeholder-avatar-10.png",
      pieces: "38 pieces",
      volume: "89.5 SOL",
      link: "/creators"
    }
  ],

  howItWorks: [
    {
      id: 1,
      title: "Create Pieces",
      description: "Upload your 3D fashion pieces and create unique digital collections to showcase your designs.",
      icon: "🎨",
      image: "/images/how-it-works/create-pieces.png",
      link: "/create-nft",
      cta: "Start Creating"
    },
    {
      id: 2,
      title: "Buy & Sell",
      description: "Purchase pieces with SOL or list your creations for sale. Set your own prices and earn from your digital fashion designs.",
      icon: "💰",
      image: "/images/how-it-works/buy-sell.png",
      link: "/explore",
      cta: "Browse Market"
    },
    {
      id: 3,
      title: "Trade Pieces",
      description: "Exchange pieces with other creators, build your digital wardrobe, and discover rare fashion items through our trading system.",
      icon: "🔄",
      image: "/images/how-it-works/trade-pieces.png",
      link: "/explore",
      cta: "Start Trading"
    }
  ]
};
